module.exports = __webpack_public_path__ + "static/media/notification.73a15e2a.svg";